import React from "react";
//#region types
import { SelectInputItemProps } from "models/propTypes/wintFormPropsTypes";
import { InvoiceFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { SelectionItem } from "models/utilTypes/selectionTypes";
import { RutRotArticleItem } from "models/formTypes/invoice";
import { RutRotSelectorProps } from "models/propTypes/invoicePropTypes";
//#endregion
//#region components
import { FormFieldLayout } from "components/common/wintForms";
import { MultipleSelection } from "components/common";
import RutRotFieldGroup from "./rutRotFieldGroup";
import { useInvoiceService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance, UtilsHelper } from "utils/helpers";

const RutRotSelector: React.FC<RutRotSelectorProps> = (props) => {
  const invoiceService = useInvoiceService();
  const { connect, values, errors, touched } = props;
  const houseWorkType = values.rutRot?.houseWorkType!;

  const [rutRotWorkTypes, setRutRotWorkTypes] = React.useState<SelectInputItemProps[]>([]);

  React.useEffect(() => {
    invoiceService.getRutRotWorkTypes().then((res) => {
      if (res && res.length > 0) {
        const newWorkTypes = res.map(
          (item): SelectInputItemProps => ({
            value: item.id,
            label: item.name ?? "",
          })
        );
        setRutRotWorkTypes(newWorkTypes.reverse());
      } else setRutRotWorkTypes([]);
    });
  }, []);

  const onRutRotArticleChange = (selectedItems: SelectionItem[]) => {
    const newValues = selectedItems.map((selectedItem) => {
      const prod = values.products?.find((p) => p.uniqueId === selectedItem.id);
      const rr: RutRotArticleItem = values.rutRot?.rutRotArticles?.find(
        (article) => article.id === selectedItem.id
      ) ?? {
        id: selectedItem.id as number,
        name: selectedItem.value,
      };

      let rutRotArticle = { ...rr, materialCost: rr.materialCost ?? 0 };
      if (!(rr.noOfHours && rr.noOfHours > 0)) {
        const numOfHours =
          prod?.quantity && prod?.quantity > 1
            ? prod.quantity
            : invoiceService.calculateAmount(prod?.price ?? 0, prod?.quantity) / 500;
        rutRotArticle = { ...rutRotArticle, noOfHours: Math.ceil(numOfHours) };
      }
      const isSuggestionUsed = selectedItems.some((uv) => uv.id === rr.materialCostSuggestionsId);
      if (isSuggestionUsed) {
        rutRotArticle = {
          ...rutRotArticle,
          materialCostSuggestionsId: undefined,
          materialCost: 0,
        };
      }

      return rutRotArticle;
    });
    const otherCost = invoiceService.calculateRutRotOtherCost(values.products ?? [], newValues);
    connect("rutRot").setValue({ ...values.rutRot, rutRotArticles: newValues, houseWorkOtherCosts: otherCost }, true);
  };

  const rutRotArticleConnector = connect("rutRot.rutRotArticles");
  const rutRotArticleTouched = rutRotArticleConnector.touched ?? false;

  return (
    <>
      <FormFieldLayout
        label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.RutRotServices)}
        descriptionText={LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.Invoice.RutRotServicesDescription,
          "",
          { houseWorkType: invoiceService.getRutOrRotText(houseWorkType) }
        )}
        direction="horizontal"
        error={rutRotArticleConnector.error}
        hasError={rutRotArticleTouched && !!rutRotArticleConnector.error}
      >
        <MultipleSelection
          items={
            values.products
              ?.filter((p: InvoiceFormTypes.Product) => p.text)
              .map((item: InvoiceFormTypes.Product) => ({
                id: item.uniqueId ?? UtilsHelper.getUniqueId(),
                value: item.text!,
              })) ?? []
          }
          value={(values.rutRot?.rutRotArticles ?? []).map((article: InvoiceFormTypes.RutRotArticleItem) => {
            return {
              id: article.id,
              value: article.name ?? "",
            };
          })}
          onChange={onRutRotArticleChange}
        />
      </FormFieldLayout>
      {values.rutRot?.rutRotArticles?.map((article, index) => (
        <RutRotFieldGroup
          key={article.id}
          connect={connect}
          values={values}
          touched={touched}
          errors={errors}
          index={index}
          row={article}
          houseWorkType={houseWorkType}
          rutRotWorkTypes={rutRotWorkTypes}
        />
      ))}
    </>
  );
};

export default RutRotSelector;
